import Modal from "src/components/common/modal";
import MyCKEditor from "src/components/common/myCKEditor";
//--------------------------------------------------------------------------------------------
export default function Form({
    closeIt,
    pop,
    popName
}:{
    closeIt: Function,
    pop: string,
    popName: string
}){
    //--------------------------------------------------------------------------------------------
    return(
        <Modal
            max
            noTopCloseIt
            closeIt = {closeIt}
            title = {popName}
            width = {"900px"}
        >
            <div className = "my-3">
                <MyCKEditor
                    disabled = {true}
                    data = {pop} 
                    onChange = {undefined}
                />
            </div>
        </Modal>
    )
}